<div class="row pt-0 pb-3">
    <!-- Featured Buttons -->
    <div class="col-md-8">
        <button type="button" [disabled]="count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" ngbTooltip="Print List" (click)="printer.print('activities-print-section', 'Activities')">
            <i class="fa fa-lg fa-print"></i>
            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Print</span>
        </button>

        <div class="btn-group mr-1">
            <button type="button" [disabled]="count == 0" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-lg fa-download"></i>
                <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Export</span>
            </button>
            <div class="dropdown-menu fs-12">
                <a (click)="exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a>
                <a (click)="exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a>
                <a (click)="exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a>
            </div>
        </div>

        <button type="button" [disabled]="count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" ngbTooltip="Filter List" (click)="toggleFilters()">
            <i class="fa fa-lg fa-filter"></i>
            <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Filter</span>
        </button>

        <div class="btn-group mr-1 ml-1">
            <button  [disabled]="count == 0" type="button" class="btn btn-secondary btn-sm dropdown-toggle mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
                <i class="fa fa-lg fa-check-square-o"></i>
                <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Columns</span>
            </button>
            <div class="dropdown-menu fs-12" style="width: 150px;">
                <div class="col-md-12 mb-3 fs-12">
                    <input type="checkbox" name="category" [(ngModel)]="c_category"> Category<br />
                    <input type="checkbox" name="date" [(ngModel)]="c_date"> Date<br />        
                    <input type="checkbox" name="driver" [(ngModel)]="c_driver"> Driver<br />    
                    <input type="checkbox" name="manifest_ctrl_no" [(ngModel)]="c_manifest_ctrl_no"> Connote Control No.<br />     
                    <input type="checkbox" name="activity" [(ngModel)]="c_activity"> Activity<br />           
                    <input type="checkbox" name="details" [(ngModel)]="c_details"> Details<br />    
                </div>
            </div>
        </div>
    </div>
    <!-- End of Featured Buttons -->

</div>

<!-- Activities List Table -->



<div class="row">
    <div class="col-md-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
        <a *ngIf="showFilters" (click)="resetFilters()" container="body" placement="top" ngbTooltip="Reset Filter"><i class="fa fa-rotate-left"></i>Reset Filter</a>
        <ngx-datatable 
                [loadingIndicator]="loadingIndicator"
                class="material"
                [rows]="jobnotifications"
                [columns]="columns"
                [columnMode]="'force'"
                [headerHeight]="30"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="15"
                [selected]="selected"
                [selectionType]="'single'"
                [scrollbarH]="true"
                [headerHeight]="showFilters?50:30"
            >

            <ngx-datatable-column prop="category_name" name="Category" headerClass="header" *ngIf="c_category">
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <select ngModel [(ngModel)]="select_category"
                            (ngModelChange)="updateFilter()" style="height:17px" class="pt-1 pb-0 mt-0 mb-0 noborder select-sm form-control form-control-sm">
                            <option disabled value="Filter by Category">Filter by Category</option>
                            <option *ngFor="let category of categories" value="{{category.category_name}}">
                                {{category.category_name}}</option>
                        </select>
                    </span>
                </ng-template>
            </ngx-datatable-column> 
            
            <ngx-datatable-column prop="created_at" name="Date" headerClass="header" *ngIf="c_date">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                </ng-template>
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters"><br/>
                        <button *ngIf="setFilter==true" type="button" style="height:17px"
                            class="btn btn-sm btn-success w-110p mb-0 mt-0 pt-0 pb-0"
                            (click)="openModal(modalContent)">Filter by Date </button>
                        <button *ngIf="setFilter==false" type="button"  style="height:17px"
                            class="btn btn-sm btn-danger w-110p mb-0 mt-0 pt-0 pb-0"
                            (click)="removeFilter()">Remove Date filter </button>
                    </span>
                </ng-template>
                
            </ngx-datatable-column> 

            <ngx-datatable-column prop="driver_full_name" name="Driver" headerClass="header" *ngIf="c_driver">
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters"><input type="text" [(ngModel)]="select_driver" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" /> </span>
                </ng-template>
            </ngx-datatable-column> 
            
            <ngx-datatable-column prop="job_control_no" name="Connote Control No" headerClass="header" *ngIf="c_manifest_ctrl_no">
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters"><input type="text" [(ngModel)]="select_ctrl_no" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" /> </span>
                </ng-template>
            </ngx-datatable-column> 
            
            <ngx-datatable-column prop="activity_name" name="Activity" headerClass="header" *ngIf="c_activity">
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters">
                        <select ngModel [(ngModel)]="select_activity"
                            (ngModelChange)="updateFilter()" style="height:17px" class="pt-1 pb-0 mt-0 mb-0 noborder select-sm form-control form-control-sm">
                            <option disabled value="Filter by Activity">Filter by Activity</option>
                            <option *ngFor="let activity of activities" value="{{activity.activity_name}}">
                                {{activity.activity_name}}</option>
                        </select>
                    </span>
                </ng-template>
                
            </ngx-datatable-column> 
                
            <ngx-datatable-column prop="text" name="Details" headerClass="header" *ngIf="c_details" [width]="250" >
                <ng-template let-value="value" let-row="row" let-sort="sortFn" ngx-datatable-cell-template>
                    <div [innerHTML]="row.render_details"></div>
                </ng-template>
                <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                    <span (click)="sort()">{{column.name}}</span>
                    <span *ngIf="showFilters"><input type="text" [(ngModel)]="select_details" style="height:17px"
                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                            (keyup)="updateFilter()" /> </span>
                </ng-template>
            </ngx-datatable-column> 
        </ngx-datatable>  
         
                
    </div>
</div>


<!-- START BILLS PRINT-->
<div id="activities-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th class="text-left" *ngIf="c_category"> CATEGORY<br />
            <th class="text-left" *ngIf="c_date"> DATE<br />        
            <th class="text-left" *ngIf="c_driver"> DRIVER<br />    
            <th class="text-left" *ngIf="c_manifest_ctrl_no"> CONNOTE CONTOL NO.<br />     
            <th class="text-left" *ngIf="c_activity"> ACTIVITY<br />           
            <th class="text-left" *ngIf="c_details"> DETAILS<br />    
        </tr>
        <tr *ngFor="let row of jobnotifications">
            <td *ngIf="c_category">{{row.category_name}}</td>
            <td *ngIf="c_date">  {{ (formatDate(row.created_at) !== null && row.created_at != '0000-00-00') ? (formatDate(row.created_at) | date: 'dd MMM yyyy') : "No Date"  }}</td>        
            <td *ngIf="c_driver"> {{row.driver}}</td>    
            <td *ngIf="c_manifest_ctrl_no"> {{row.job_control_no}}</td>     
            <td *ngIf="c_activity"> {{row.activity_name}}</td>            
            <td *ngIf="c_details"> {{row.text}}</td>     
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!-- START OF MODAL FORM -->
<ng-template #modalContent>
    <div class="modal-header">
        <h5 class="modal-title"> Date Range Filter</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="frmDate" (ngSubmit)="onSubmitDate(frmDate.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-6">
                    <label class="form-control-label">Start Date <span class="text-danger">*</span> </label>
                    <input formControlName="start_date" class="form-control form-control-sm" type="date">
                </div>

                <div class="form-group col-6">
                    <label class="form-control-label">End Date <span class="text-danger">*</span> </label>
                    <input formControlName="end_date" class="form-control form-control-sm" type="date">
                </div>
                <small class="col text-danger" *ngIf="frmDate.errors">{{ frmDate.errors?.dates | json }}</small>
            </div>
        </div>

        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <button [disabled]="!frmDate.valid" class="btn btn-sm btn-success" type="submit">Filter</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL FORM -->

